import ApiService from "../../../services/api.service";

const DiscountXyProductService = {
	getItems(payload, data) {
		return ApiService.post(`/item/search/categories?page=${payload.page}&limit=${payload.limit}`, data ? data : { categoryId: 14 })
	},
	getList(search) {
		return ApiService.post(`/xyProduct/listSearch?search=${search}`, { page: 1, limit: 10000 })
	},
	createProduct(data) {
		return ApiService.post(`/xyProduct/create`, data)
	},
	updateProduct(data) {
		return ApiService.put(`/xyProduct/update/${data.id}`, data)
	},
	deleteProduct(id) {
		return ApiService.delete(`/xyProduct/delete/${id}`)
	},
	activeOrInactive(item) {
		return ApiService.delete(`/xyProduct/delete/${item.id}?status=${item.status}`)
	},
	setImageProduct(id, form) {
		return ApiService.post(`/xyProduct/addPhoto/${id}`, form)
	},
	generateBarcode() {
		return ApiService.get(`/item/generate-barcode-with-product`)
	},
	getListByGroup(groupId, depId) {
		return ApiService.get(`/xyGroup/productListByGroupId/${groupId}/${depId}`)
	},
	getListByDepId(depId) {
		return ApiService.get(`/xyGroup/productList/${depId}`)
	},
	deletePhotoProduct(productId, photoId) {
		return ApiService.get(`/xyProduct/${productId}/remove-photo/${photoId}`)
	}
}

export default DiscountXyProductService
